"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPanelTitle = exports.StyledPanelText = exports.StyledPanel = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helpers = require("../utils/helpers");

var _Elements = require("../Elements");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 0.775rem;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      padding: 0;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      border: none;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      border: 1px solid ", ";\n\n      code {\n        background-color: ", ";\n      }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      color: ", ";\n      border: 1px solid ", ";\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      color: ", ";\n      border: 1px solid ", ";\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      color: ", ";\n      border: 1px solid ", ";\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      color: ", ";\n      border: 1px solid ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      color: ", ";\n      border: 1px solid ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  padding: ", ";\n  border-radius: ", ";\n\n  code {\n    background-color: ", ";\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledPanel = _styledComponents.default.div(_templateObject(), (0, _helpers.clearfix)(), function (props) {
  return props.theme.palette.offWhite;
}, function (props) {
  return props.theme.palette.lightestGray;
}, function (props) {
  return (0, _helpers.unitCalc)(props.theme.baseline, 0.66, '*');
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.palette.white;
}, function (props) {
  return props.dark && (0, _styledComponents.css)(_templateObject2(), function (props) {
    return props.theme.palette.darkestGray;
  }, function (props) {
    return props.theme.palette.white;
  }, function (props) {
    return props.theme.palette.offBlack;
  });
}, function (props) {
  return props.black && (0, _styledComponents.css)(_templateObject3(), function (props) {
    return props.theme.palette.black;
  }, function (props) {
    return props.theme.palette.white;
  }, function (props) {
    return props.theme.palette.offBlack;
  });
}, function (props) {
  return props.darkBlue && (0, _styledComponents.css)(_templateObject4(), function (props) {
    return props.theme.palette.Brand_Blue_250;
  }, function (props) {
    return props.theme.palette.white;
  }, function (props) {
    return props.theme.palette.darkerBlue;
  });
}, function (props) {
  return props.blue && (0, _styledComponents.css)(_templateObject5(), function (props) {
    return props.theme.palette.blue;
  }, function (props) {
    return props.theme.palette.white;
  }, function (props) {
    return props.theme.palette.darkBlue;
  });
}, function (props) {
  return props.lightBlue && (0, _styledComponents.css)(_templateObject6(), function (props) {
    return props.theme.palette.lightBlue;
  }, function (props) {
    return props.theme.palette.black;
  }, function (props) {
    return props.theme.palette.blue;
  });
}, function (props) {
  return props.white && (0, _styledComponents.css)(_templateObject7(), function (props) {
    return props.theme.palette.white;
  }, function (props) {
    return props.theme.palette.lightestGray;
  }, function (props) {
    return props.theme.palette.offWhite;
  });
}, function (props) {
  return props.noBorder && (0, _styledComponents.css)(_templateObject8());
}, function (props) {
  return props.noPadding && (0, _styledComponents.css)(_templateObject9());
});

exports.StyledPanel = StyledPanel;

var StyledPanelText = _styledComponents.default.div(_templateObject10());

exports.StyledPanelText = StyledPanelText;
var StyledPanelTitle = (0, _styledComponents.default)(_Elements.CalciteH4)(_templateObject11());
exports.StyledPanelTitle = StyledPanelTitle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/calcite-react/Panel/Panel-styled.js
// module id = 369
// module chunks = 0